<template>
  <div class="layer-group">
    <div :id="layer.slug" class="layer-title">{{ layer.display_name }}</div>
    <div class="layer-products">
      <draggable
        v-model="myList"
        :group="layer.slug"
        ghost-class="ghost"
        @start="drag = true"
        @end="drag = false"
        class="draggable-container"
        draggable=".draggable"
      >
        <component
          v-for="layerProduct in myList"
          :key="layerProduct.id"
          :layer-product="layerProduct"
          class="draggable"
          :is="layerProductComponentType(layerProduct)"
        />

        <add-item
          v-for="(n, index) in addProductComponentCount"
          :key="index"
          :isRequired="productRequired(index)"
          :layerDisplayName="layer.display_name"
          :layerId="layer.id"
          :isFetchingProduct="false"
          v-show="!capsulePublished"
        />
      </draggable>
    </div>
  </div>
</template>

<script>
import AddItem from "@/components/capsuleBuilder/layerGroup/AddItem";
import draggable from "vuedraggable";
import LayerProduct from "@/components/capsuleBuilder/layerGroup/LayerProduct";
import LayerProductEmpty from "@/components/capsuleBuilder/layerGroup/LayerProductEmpty";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AddItem,
    draggable,
    LayerProduct,
    LayerProductEmpty
  },

  props: {
    layer: {
      type: Object,
      required: true
    }
  },

  methods: {
    ...mapActions([
      "pollPendingCapsuleProducts",
      "updateLayerProductSequences"
    ]),

    productRequired(n) {
      return (
        this.requiredProductsCount > 0 && this.addProductComponentCount > n
      );
    },

    layerProductComponentType(layerProduct) {
      return layerProduct.product ? "LayerProduct" : "LayerProductEmpty";
    }
  },

  computed: {
    ...mapGetters(["currentCapsule"]),

    capsulePublished() {
      return this.currentCapsule.status == "published";
    },

    myList: {
      get() {
        return [...this.layer['layer_products']];
      },

      set(value) {
        let payload = { layerId: this.layer.id, layerProducts: value };
        this.updateLayerProductSequences(payload);
      }
    },

    minimumRequiredProducts() {
      return this.$constants.LAYER_GROUPS.findRecursive(
        x => x.slug == this.layer.slug,
        "subGroups"
      )["minimum"];
    },

    requiredProductsCount() {
      return this.minimumRequiredProducts - this.layer.layer_products_count;
    },

    addProductComponentCount() {
      return Math.max(1, this.requiredProductsCount); // Return minimum 1
    }
  }
};
</script>

<style lang="scss" scoped>
.layer-group {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-bottom: 30px;
  padding-top: 0;
}

.layer-title {
  padding: 5px;
  padding-left: 15px;
  background-color: #f6f6f6;
  text-transform: capitalize;
  letter-spacing: 1px;
}

.layer-products {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: space-evenly;
  text-align: center;
}

.draggable-container {
  justify-content: space-evenly;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/LayerGroup.vue